<div class="card-filter-wrapper" [ngClass]="{ 'open-combo': openCombo !== FilterType.None }" *ngIf="state && users">
    <div class="card-filter">
        <div class="filter-button-wrapper">
            <div class="combo combo-user" *ngIf="users.length > 1">
                <div class="filter-button" (click)="selectCombo(FilterType.User)">
                    <span>{{
                        state.selectedUser
                            ? state.selectedUser.name + '-' + state.selectedUser.id
                            : 'כל המשתמשים (' + users.length + ')'
                    }}</span>
                    <img
                        src="/assets/images/direct-debit/icon-angle-left.svg"
                        [ngClass]="{ 'open-combo': openCombo === FilterType.User }"
                        class="angle"
                        alt=""
                    />
                </div>

                <div *ngIf="openCombo === FilterType.User" class="all-actions-popup users-popup">
                    <div class="modal-header d-md-none">
                        <span class="title">בחירת בעל כרטיס</span>
                        <div style="padding-left: 1rem">
                            <button (click)="selectCombo(FilterType.None)" class="close"></button>
                        </div>
                    </div>

                    <div class="pop-up-content">
                        <div class="title-wrapper">
                            <span
                                (click)="selectUser(null)"
                                class="show-me-all"
                                [ngClass]="{ 'pick-name': !state.selectedUser }"
                                >כל השותפים בחשבון</span
                            >
                        </div>

                        <ul>
                            <li
                                *ngFor="let user of users"
                                (click)="selectUser(user)"
                                class="user-item"
                                [ngClass]="{ 'pick-name': state.selectedUser?.id == user.id }"
                            >
                                {{ user.name }} - {{ user.id }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="combo combo-cards" *ngIf="banks && totalCard > 1">
                <div
                    class="filter-button"
                    (click)="selectCombo(FilterType.Card)"
                    [ngClass]="{ 'all-cards': !state.selectedCard }"
                    id="all-cards"
                >
                    <span *ngIf="!state.selectedCard && !state.bankAccount">כל הכרטיסים ({{ totalCard }})</span>
                    <span *ngIf="state.bankAccount">{{ state.bankAccount.bankName }} {{ state.bankAccount.branchID }}-{{
                        state.bankAccount.accountNumber
                    }}</span>

                    <div *ngIf="state.selectedCard && !state.bankAccount" class="combo-text cards">
                        <img [src]="state.selectedCard[0].cardImage" class="card-image" />
                        {{ state.selectedCard[0].shortCardNumber }} {{ state.selectedCard[0].cardName }}
                    </div>
                    <img
                        src="/assets/images/direct-debit/icon-angle-left.svg"
                        class="angle"
                        [ngClass]="{ 'open-combo': openCombo === FilterType.Card }"
                        alt=""
                    />
                </div>
                <div *ngIf="openCombo === FilterType.Card" class="all-actions-popup cards-popup">
                    <div class="modal-header d-md-none">
                        <span class="title">בחירת כרטיס</span>
                        <div style="padding-left: 1rem">
                            <button (click)="selectCombo(FilterType.None)" class="close"></button>
                        </div>
                    </div>
                    <div class="pop-up-content">
                        <div class="title-wrapper">
                            <span
                                (click)="selectCard(null)"
                                class="show-me-all cards"
                                [ngClass]="{ 'pick-name': !state.selectedCard }"
                                >כל הכרטיסים</span
                            >
                        </div>
                        <ng-container *ngFor="let bankAccount of banks">
                            <span class="bank-details"  [ngClass]="{'pick-name': state.bankAccount && state.bankAccount.bankAccountIndex === bankAccount.bankAccountIndex}"
                            (click)="selectCardsByBankId(bankAccount)">{{ bankAccount.bankName }} {{ bankAccount.branchID }}-{{
                                    bankAccount.accountNumber
                                }}</span
                            >
                            <ul>
                                <li
                                    *ngFor="let card of getActivateCard(bankAccount, true)"
                                    class="card-item"
                                    [ngClass]="{ 'pick-name': state.selectedCard?.cardIndex === card.cardIndex }"
                                    (click)="selectCard(card)"
                                >
                                    <img [src]="card.cardImage" class="card-image" />{{ card.shortCardNumber }}
                                    {{ card.cardName }}
                                </li>
                            </ul>
                            <span *ngIf="getActivateCard(bankAccount, false).length">
                                <span class="unactive-cards">כרטיסים שאינם פעילים</span>

                                <ul>
                                    <li
                                        *ngFor="let card of getActivateCard(bankAccount, false)"
                                        class="card-item"
                                        [ngClass]="{ 'pick-name': state.selectedCard?.cardIndex === card.cardIndex }"
                                        (click)="selectCard(card)"
                                    >
                                        <img [src]="card.cardImage" class="card-image" />{{ card.shortCardNumber }}
                                        {{ card.cardName }}
                                    </li>
                                </ul>
                            </span>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="combo combo-status">
                <div class="filter-button" id="all-status" (click)="selectCombo(FilterType.Status)">
                    <span> {{ getStatusName(state.selectedStatus) }}</span>
                    <img
                        src="/assets/images/direct-debit/icon-angle-left.svg"
                        class="angle"
                        [ngClass]="{ 'open-combo': openCombo === FilterType.Status }"
                        alt=""
                    />
                </div>

                <div *ngIf="openCombo === FilterType.Status" class="all-actions-popup status-popup">
                    <div class="modal-header d-md-none">
                        <span class="title">בחירת בעל כרטיס</span>
                        <div style="padding-left: 1rem">
                            <button (click)="selectCombo(FilterType.None)" class="close"></button>
                        </div>
                    </div>

                    <div class="pop-up-content">
                        <ul>
                            <li
                                *ngFor="let status of getAllStatus()"
                                (click)="selectStatus(status.type)"
                                class="user-item"
                                [ngClass]="{ 'pick-name': state.selectedStatus == status.type }"
                            >
                                {{ getStatusName(status.type) }}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="print-wrapper" [ngClass]="{ disabled: hoks.length == 0 }">
            <span class="print" id="print" (click)="hoks.length == 0 ? null : onPrint()">הדפסה</span>
            <span class="excel" id="excel" (click)="hoks.length == 0 ? null : exportToExcel()">הורדה ל Excel</span>
        </div>
    </div>
</div>
